import React from 'react';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '../ui/accordion';
import { FAQ_ITEMS } from './landingData';

export function FAQSection() {
  return (
    <section className="py-12 md:py-24 bg-white" aria-label="Frequently Asked Questions">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">

        <div className="text-center mb-14">
          <h2
            className="text-4xl md:text-5xl font-bold text-slate-900 leading-tight"
            style={{ fontFamily: 'Manrope' }}
          >
            Frequently Asked Questions
          </h2>
          <p className="mt-4 text-lg text-slate-600">
            Everything you need to know before getting started.
          </p>
        </div>

        <Accordion type="single" collapsible className="divide-y divide-slate-200 border border-slate-200 rounded-2xl overflow-hidden">
          {FAQ_ITEMS.map((item, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="px-6 border-0">
              <AccordionTrigger className="text-base md:text-lg font-semibold text-slate-900 hover:no-underline py-5 text-left">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 text-base leading-relaxed pb-5">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

      </div>
    </section>
  );
}
